import { render } from "./AdminReleases.vue?vue&type=template&id=948e5128&scoped=true&ts=true"
import script from "./AdminReleases.vue?vue&type=script&lang=ts"
export * from "./AdminReleases.vue?vue&type=script&lang=ts"

import "./AdminReleases.vue?vue&type=style&index=0&id=948e5128&scoped=true&lang=css"
import "./AdminReleases.vue?vue&type=style&index=1&id=948e5128&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-948e5128"]])

export default __exports__